// extracted by mini-css-extract-plugin
export var container = "project-module--container--I2vxk";
export var card = "project-module--card--iUGx7";
export var imgBg = "project-module--imgBg--0jrOs";
export var transform = "project-module--transform--qHk5i";
export var title = "project-module--title--8PlMV";
export var tags = "project-module--tags--HosMp";